<ion-header>
    <ion-toolbar color="primary">
        <ion-buttons slot="start">
            <ion-button (click)="dismiss()" [disabled]="isUploading">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{ pageTitle }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="save()" [disabled]="isUploading">
                <ion-icon slot="icon-only" name="save-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<div *ngIf="isUploading" class="upload-overlay">
    <ion-spinner name="crescent"></ion-spinner>
    <p>{{ i18n.tr('Bestand uploaden...') }}</p>
</div>

<ion-content
    class="ion-padding"
    [class.content-disabled]="isUploading"
    [scrollEvents]="true"
    [fullscreen]="true"
>
    <div *ngIf="isLoading" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
    </div>

    <div *ngIf="!isLoading">
        <ion-list lines="full">
            <ion-item
                class="form-item-horizontal"
                [class.order-invalid]="orderInputValue && !selectedOrder"
                style="position: relative"
            >
                <ion-label>{{ i18n.tr('Order') }}</ion-label>
                <ion-input
                    [(ngModel)]="orderInputValue"
                    (ionInput)="onOrderInput($event)"
                    placeholder="{{ i18n.tr('Zoek en selecteer een order') }}"
                ></ion-input>
            </ion-item>

            <div
                *ngIf="orderSuggestions.length > 0"
                class="autocomplete-dropdown"
            >
                <ion-list>
                    <ion-item
                        button
                        *ngFor="let suggestion of orderSuggestions"
                        (click)="selectOrder(suggestion)"
                        class="suggestion-item"
                    >
                        <ion-label>{{ suggestion.text }}</ion-label>
                    </ion-item>
                </ion-list>
            </div>

            <ion-item class="form-item-horizontal">
                <ion-label>{{ i18n.tr('Titel') }}</ion-label>
                <ion-input
                    [(ngModel)]="note.Titel"
                    placeholder="{{ i18n.tr('Voer een titel in') }}"
                ></ion-input>
            </ion-item>

            <ion-item class="form-item-horizontal">
                <ion-label>{{ i18n.tr('Door') }}</ion-label>
                <ion-input
                    [(ngModel)]="note.Door"
                    [readonly]="true"
                ></ion-input>
            </ion-item>

            <ion-item class="form-item-horizontal">
                <ion-label>{{ i18n.tr('[en]For') }}</ion-label>
                <ion-select
                    [(ngModel)]="note.Voor"
                    interface="popover"
                    placeholder="{{ i18n.tr('Selecteer gebruiker') }}"
                    [selectedText]="getVoorUserText()"
                    [interfaceOptions]="{ cssClass: 'custom-select-popover' }"
                >
                    <ion-select-option
                        *ngFor="let user of allUsers"
                        [value]="user.id"
                    >
                        {{ user.text }}
                    </ion-select-option>
                </ion-select>
            </ion-item>
            <ion-item class="form-item-horizontal">
                <ion-label>{{ i18n.tr('[en]Due date') }}</ion-label>
                <ion-datetime-button datetime="duedate"></ion-datetime-button>
                <ion-icon
                    name="calendar-outline"
                    slot="end"
                    color="medium"
                    class="clickable-icon"
                    (click)="openDateModal()"
                ></ion-icon>
                <ion-modal [keepContentsMounted]="true" #dateModal>
                    <ng-template>
                        <ion-datetime
                            id="duedate"
                            [(ngModel)]="note.DueDate"
                            presentation="date"
                            (ionChange)="onDateChange()"
                        ></ion-datetime>
                    </ng-template>
                </ion-modal>
            </ion-item>

            <!-- ! new scheduler  stuffs-->
            <ng-container *ngIf="isNew">
                <!-- Priority on its own line -->
                <ion-item class="form-item-horizontal">
                    <ion-label>{{ i18n.tr('[en]Priority') }}</ion-label>
                    <ion-select
                        [(ngModel)]="note.prioriteit"
                        interface="popover"
                    >
                        <ion-select-option
                            *ngFor="let option of priorityOptions"
                            [value]="option.value"
                            >{{ option.name }}</ion-select-option
                        >
                    </ion-select>
                </ion-item>
                <ion-grid class="scheduler-grid">
                    <ion-row class="ion-align-items-center">
                        <ion-col size="6">
                            <ion-item class="form-item-horizontal no-padding">
                                <ion-label
                                    >{{ i18n.tr('[en]Fixed Schedule')
                                    }}</ion-label
                                >
                                <ion-toggle
                                    slot="end"
                                    [(ngModel)]="note.isFixed"
                                ></ion-toggle>
                            </ion-item>
                        </ion-col>
                        <ion-col
                            size="6"
                            *ngIf="!note.isFixed"
                            class="ion-padding-end"
                        >
                            <ion-item class="form-item-horizontal no-padding">
                                <ion-label
                                    >{{ i18n.tr('[en]Est. Hours') }}</ion-label
                                >
                                <ion-input
                                    type="number"
                                    [(ngModel)]="note.estHours"
                                    placeholder="1"
                                ></ion-input>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>

                <!-- Start/End Time Pickers (only show when Fixed Time is ON) -->
                <ng-container *ngIf="note.isFixed">
                    <ion-grid class="scheduler-grid">
                        <ion-row>
                            <ion-col size="6">
                                <ion-item
                                    class="form-item-horizontal no-padding"
                                >
                                    <ion-label
                                        >{{ i18n.tr('[en]Start') }}</ion-label
                                    >
                                    <ion-datetime-button
                                        datetime="startTimePicker"
                                    ></ion-datetime-button>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item
                                    class="form-item-horizontal no-padding"
                                >
                                    <ion-label
                                        >{{ i18n.tr('[en]End') }}</ion-label
                                    >
                                    <ion-datetime-button
                                        datetime="endTimePicker"
                                    ></ion-datetime-button>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ng-container>
            </ng-container>
            <!-- ! new  scheduler stuffs -->

            <div class="quill-container">
                <quill-editor
                    [(ngModel)]="note.Bericht"
                    [modules]="quillConfig"
                ></quill-editor>
            </div>
        </ion-list>

        <div *ngIf="files && files.length > 0" class="files-section">
            <ion-list-header>
                <ion-label>{{ i18n.tr('Bestanden') }}</ion-label>
            </ion-list-header>
            <ion-list>
                <!-- FIX: Wrap item in a div to hold the progress bar -->
                <div *ngFor="let file of files">
                    <ion-item
                        button
                        (click)="openFile(file)"
                        [detail]="!isAudioFile(file)"
                    >
                        <!-- FIX: Icon is now dynamic based on file type -->
                        <ion-icon
                            [name]="getIconForFile(file)"
                            slot="start"
                            color="tertiary"
                        ></ion-icon>
                        <ion-label>
                            <h2>{{ file.filename }}</h2>
                            <p>{{ file.dd | date:'medium' }}</p>
                        </ion-label>
                        <!-- FIX: Show play/pause for audio, or an 'open' icon for others -->
                        <ion-icon
                            *ngIf="isAudioFile(file)"
                            [name]="isPlaying(file) ? 'pause-circle' : 'play-circle'"
                            slot="end"
                            color="primary"
                            class="action-icon"
                        ></ion-icon>
                        <ion-icon
                            *ngIf="!isAudioFile(file)"
                            name="open-outline"
                            slot="end"
                            color="medium"
                            class="action-icon"
                        ></ion-icon>
                    </ion-item>
                    <!-- FIX: Add progress bar for playing audio -->
                    <ion-progress-bar
                        *ngIf="isPlaying(file)"
                        [value]="audioProgress"
                        color="secondary"
                    ></ion-progress-bar>
                </div>
            </ion-list>
        </div>
    </div>
    <ion-fab
        *ngIf="!keyboardOpen"
        vertical="bottom"
        horizontal="center"
        slot="fixed"
    >
        <ion-fab-button
            size="big"
            class="mic-button"
            (click)="openVoiceMemoModal()"
            color="primary"
        >
            <ion-icon name="mic-outline"></ion-icon>
        </ion-fab-button>
    </ion-fab>

    <!-- START: Add Modals for Time Pickers -->
    <ion-modal [keepContentsMounted]="true">
        <ng-template>
            <ion-datetime
                id="startTimePicker"
                presentation="time"
                [(ngModel)]="note.startTime"
            ></ion-datetime>
        </ng-template>
    </ion-modal>

    <ion-modal [keepContentsMounted]="true">
        <ng-template>
            <ion-datetime
                id="endTimePicker"
                presentation="time"
                [(ngModel)]="note.endTime"
            ></ion-datetime>
        </ng-template>
    </ion-modal>
    <!-- END: Add Modals for Time Pickers -->
</ion-content>
